import { Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useIsMobile } from '@/context/IsMobileContext.tsx';
import { SURFACE } from '@/styles/surfaces.ts';

const { Text } = Typography;

const STEPS = ['Welcome', 'Your Property', 'Done'];

/**
 * Where the client is in the first-run wizard.
 *
 * Ant Design's Steps with connector lines ate the top quarter of a 640px
 * modal for what is a three pane, two minute flow. This says the same thing
 * in one line: the current step named, the rest as ticks.
 */
export const WizardProgress = ({ current }: { current: number }) => {
  const { isMobile } = useIsMobile();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: isMobile ? 18 : 22,
      }}
    >
      {STEPS.map((label, index) => {
        const done = index < current;
        const active = index === current;

        return (
          <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11,
                  fontWeight: 600,
                  background: done || active ? SURFACE.accent.solid : '#e9edf5',
                  color: done || active ? '#ffffff' : SURFACE.text.faint,
                  flexShrink: 0,
                }}
              >
                {done ? <CheckOutlined style={{ fontSize: 9 }} /> : index + 1}
              </span>
              {/* Only the current step is named on mobile: three labels plus
                  connectors wrap on a narrow screen. */}
              {(!isMobile || active) && (
                <Text
                  style={{
                    fontSize: 13,
                    fontWeight: active ? 600 : 500,
                    color: active ? SURFACE.text.strong : SURFACE.text.faint,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {label}
                </Text>
              )}
            </div>
            {index < STEPS.length - 1 && (
              <span
                style={{
                  height: 2,
                  borderRadius: 1,
                  flex: 1,
                  minWidth: 12,
                  background: done ? SURFACE.accent.solid : '#e9edf5',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
